import { toast } from "react-toastify";

export function convertIntToString(value, enumObject) {
  return Object.keys(enumObject).find((key) => enumObject[key] === value);
}

export function convertStringToInt(value, enumObject) {
  if (typeof value !== "string") {
    throw new Error("Input value must be a string");
  }

  if (!enumObject || typeof enumObject !== "object") {
    throw new Error("Invalid enum object");
  }

  const result = enumObject[value];
  if (result === undefined) {
    throw new Error(`Value "${value}" does not exist in the enum object.`);
  }

  return result;
}
export function showInfoToast(message) {
  toast.info(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    progress: undefined,
    theme: "dark",
  });
}

export function showErrorToast(message) {
  toast.error(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    progress: undefined,
    theme: "dark",
  });
}

export function showSuccessToast(message) {
  toast.success(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    progress: undefined,
    theme: "dark",
  });
}

export function showWarningToast(message) {
  toast.warning(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    progress: undefined,
    theme: "dark",
  });
}

export function showErrorToastWithDelay(message, duration = 4000) {
  toast.error(message, {
    position: "top-right",
    autoClose: duration,
    hideProgressBar: false,
    closeOnClick: true,
    progress: undefined,
    theme: "dark",
  });
}
